import { Alert } from '@libs/ui/ds'
import { usePlanningFormTranslation } from '@libs/utils/translations'
import type { RestItem } from '@spa/constants/RestTypes'
import React from 'react'
import type { FC } from 'react'

type Props = {
  counterType: RestItem['counter_type']
}
const NegativeCompensatoryRest: FC<Props> = ({ counterType }) => {
  const { t } = usePlanningFormTranslation()

  return (
    <Alert intent='semantic.red' data-testid='negative-compensatory'>
      {counterType === 'public_holiday' &&
        t('restForm.publicHolidayNegativeCompensatoryRest')}
      {counterType === 'compensatory' &&
        t('restForm.compensatoryNegativeCompensatoryRest')}
    </Alert>
  )
}

export default NegativeCompensatoryRest
